/**
 * PC 端浏览器检测与跳转
 *
 * 检测当前环境是否为 PC 端浏览器（Windows / macOS），
 * 如果是则跳转到对应项目的 PC 端页面（www.52dsy.com 等）。
 * 开发环境下不执行跳转，方便本地调试。
 */
export function checkPcRedirect(pcUrl: string) {
  // #ifdef H5
  if (import.meta.env.DEV) {
    // 开发模式，不跳转
    return;
  }

  if (!pcUrl) {
    // 还未加载项目数据
    return;
  }

  // 检测是否是电脑端打开
  const platform = uni.getSystemInfoSync().platform;

  if (platform === 'windows' || platform === 'mac') {
    let url = pcUrl;

    const curRoute = window.location.href;
    const routeParams = new URLSearchParams(window.location.search);

    // 从店铺页面进入（PC 路由：/shop/{id}）
    if (curRoute.includes('/pages/shop/details')) {
      const id = routeParams.get('id');
      if (id) {
        url += `/shop/${id}`;
      }
    }
    // 从商品详情进入（PC 路由：/{id}）
    else if (curRoute.includes('/pages/goods/details')) {
      const id = routeParams.get('id');
      if (id) {
        url += `/${id}`;
      }
    }

    window.location.href = url;
  }
  // #endif
}
